export enum MatchKind {
  FailedCollection = 0,
  ExtraBooking = 1,
  IncomingInsurance = 2,
  Disbursement = 3,
  UnknownCredit = 4,
  UnknownDebit = 5,
  OpeningCosts = 6,
}
